import React, { Component } from 'react';
import { api } from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";

export default class FormEditModel extends Component {
	constructor () {
		super();
		this.state = {
			modelo: "",
			external: "",
			fetching: false
		};
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleModelDelete = this.handleModelDelete.bind(this);
		this.handleExternalChange = this.handleExternalChange.bind(this);
	}
	componentWillMount () {
		this.setState({fetching: true});
		api.get(`models/${this.props.modelId}`)
		.then(({data})=>{
			this.setState({modelo: data.name,external:data.external});
		})
		.catch((error)=>{
			swal("Error", `Status: ${error.response.status}`,"error");
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleModelDelete () {
		swal({
			title: "Desea eliminar este modelo?",
			confirmButtonText: "Si",
			confirmButtonClass: "alert",
			showCancelButton: true,
			cancelButtonText: 'No',
			type: "info"
		}).then(()=>{
			this.setState({fetching: true});
			api.delete(`models/${this.props.modelId}`)
			.then(()=>{
				swal({
					title: "Modelo eliminado",
					type: "success"
				});
				this.setState({fetching: false});
				this.props.closeModal();
			})
			.catch(({reponse: {status}})=>{
				this.setState({fetching: false});
				swal({
					title: "Ha ocurrido un error",
					text: `Status: ${status}`,
					type: "error"
				});
			})
		},(dismiss)=>{
			if (dismiss === 'cancel') {

			}
		})
	}
	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.patch(`/models/${this.props.modelId}`,{name: this.state.modelo,external: this.state.external})
		.then((response)=>{
			swal("Modelo actualizado!",this.state.modelo,"success");
			this.setState({fetching: false});
			this.props.update();
		})
		.catch(({response: {status}})=>{
			if (status === 406) {
				this.setState({fetching: false});
				swal("Error", `Ya existe un modelo con ese nombre`,"error");
			} else {
				swal("Error", `Status: ${status}`,"error");
			}
		});
	}
	handleModelChange ({target: {value}}) {
		this.setState({modelo: value});
	}
	handleExternalChange ({target: {value}}) {
		this.setState({external: !this.state.external});
	}
	render() {
		/*
		 ES MODELO
		 */
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Editar modelo</div>
				<div className="row">
					<label className="columns small-4">
						<em>Modelo</em>
						<input type="text" value={this.state.modelo} onChange={this.handleModelChange} required disabled={this.context.getLp() < 2}/>
					</label>
					<label className="columns small-1">
						<em>Externo</em>
						<br/>
						<input type="checkbox" checked={this.state.external} value={this.state.external} onChange={this.handleExternalChange} disabled={this.context.getLp() < 2}/>
					</label>
					<label className="columns small-4">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching || this.context.getLp() < 2}>Guardar</button>
					</label>
					<label className="columns small-3">
						<em> </em>
						<button type="button" className="button alert expanded" onClick={this.handleModelDelete} disabled={this.state.fetching || this.context.getLp() < 3}>Eliminar</button>
					</label>
				</div>
			</form>
		);
	}
}

FormEditModel.contextTypes = {
	getLp: React.PropTypes.func
};


/** WEBPACK FOOTER **
 ** ./src/components/form-edit-model.js
 **/